import { render, staticRenderFns } from "./SurveyResponse.vue?vue&type=template&id=5c522c04&scoped=true"
import script from "./SurveyResponse.vue?vue&type=script&lang=js"
export * from "./SurveyResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c522c04",
  null
  
)

export default component.exports